// services/authService.ts - COMPLETE WORKING VERSION
import { auth } from "../utils/eira/firebase";
import tokenService from "./tokenService";

class AuthService {
  async isAuthenticated(): Promise<boolean> {
    return await tokenService.isTokenValid();
  }

  async getCurrentUser() {
    return await tokenService.getStoredUser();
  }

  async getClinicUserId(): Promise<string | null> {
    return await tokenService.getClinicUserId();
  }

  async logout(): Promise<void> {
    try {
      await auth.signOut();
      await tokenService.clearStoredToken();
    } catch (error) {
      console.error("Logout failed:", error);
      await tokenService.clearStoredToken();
    }
  }

  async getAccessToken(): Promise<string | null> {
    return await tokenService.getCurrentToken();
  }
}

export default new AuthService();
